import React, {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {VAT} from '../../../../../../../utils';

interface UnitSummaryDetailsProps {
  vatIncluded: boolean,
  lines: {amount: number | string}[],
  date: Date,
}

const UnitSummaryDetails = ({
                              vatIncluded,
                              lines,
                              date,
                            }: UnitSummaryDetailsProps) => {
  const [amountSum, setAmountSum] = useState('0');
  const [vatSum, setVatSum] = useState('0');
  const [totalAmountSum, setTotalAmountSum] = useState('0');

  useEffect(() => {
    const arraySum = lines
      .map(summaryData => {
        const amount = (typeof summaryData.amount === 'string') ? parseFloat(summaryData.amount) : summaryData.amount;
        return (vatIncluded)
          ? amount / (1 + VAT.fraction(date))
          : amount;
      })
      .filter(Boolean)
      .reduce((acc, item) => acc + item, 0);

    setAmountSum(arraySum.toFixed(2));
    setVatSum((arraySum * VAT.fraction(date)).toFixed(2));
    setTotalAmountSum((arraySum * (1 + VAT.fraction(date))).toFixed(2));
  }, [lines, vatIncluded]);

  return (
    <div>
      <div className="mb-2 d-flex justify-content-between w-250px">
        <div className="text-nowrap font-size-lg custom-brand-color">
          <FormattedMessage
            id="receipts-popup-total"
            defaultMessage="Total"
          />
        </div>
        <div
          dir="ltr"
          className="bg-secondary font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-150px h-30px">
          {amountSum}
        </div>
      </div>
      <div className="mb-2 d-flex justify-content-between w-250px">
        <div className="text-nowrap font-size-lg custom-brand-color">
          <FormattedMessage
            id="receipts-popup-vat"
            defaultMessage="vat"
            values={{vatPercents: VAT.toString(date)}}
          />
        </div>
        <div
          dir="ltr"
          className="bg-secondary font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-150px h-30px">
          {vatSum}
        </div>
      </div>
      <div className="mb-2 d-flex justify-content-between w-250px">
        <div className="text-nowrap font-size-lg custom-brand-color">
          <FormattedMessage
            id="receipts-popup-amount"
            defaultMessage="Amount"
          />
        </div>
        <div
          dir="ltr"
          className="bg-secondary font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-150px h-30px">
          {totalAmountSum}
        </div>
      </div>
    </div>
  );
};

export default UnitSummaryDetails;
